import {Observable} from 'rxjs';

import {FrontWindow} from '../../libs/shared/helpers/src/browser/browserHelpers';
import {TaskMetadata} from '../../libs/shared/helpers/src/instrumentation/eventLoopPerformanceHelpers';

/**
 * Returns an observable that emits once during an idle callback.
 *
 * Warning: idle callbacks don't fire while the window is hidden or obscured. Make sure you target the right window!
 * Consider using fromIdleOrHiddenCallback instead.
 */
export function fromIdleCallback(
  window: FrontWindow,
  metadata: TaskMetadata,
  timeout?: number,
): Observable<IdleDeadline> {
  return new Observable((subscriber) => {
    let wasCalled = false;

    const handle = window.requestInstrumentedIdleCallback(
      (deadline) => {
        wasCalled = true;

        try {
          subscriber.next(deadline);
          subscriber.complete();
        } catch (error) {
          subscriber.error(error);
        }
      },
      metadata,
      timeout ? {timeout} : undefined,
    );

    return () => {
      if (wasCalled) {
        return;
      }

      window.cancelIdleCallback(handle);
    };
  });
}
